<pcg-table-top *ngIf="showTableTop"
	[canGlobalSearch]="canGlobalSearch"
	[canExactMatchSearch]="canExactMatchSearch" 
	[canShowHide]="canShowHide" 
	[canShowHideColumns]="canShowHideColumns"
	[pageSizeSource]="pageSizeSource"
	[filterSource]="filterSource"
	[pageLengths]="pageLengths"
	[exactMatchSource]="exactMatchSource"
	[columnDefs]="columnDefs"
	[filterId]="filterId"
	[filters]="(filterId ? ajaxData : null)"
	[canResetFilters]="canResetFilters"
	[ajaxData]="ajaxData" 
	[filterMap]="filterMap"
></pcg-table-top>

<tr class="search-row" *cdkHeaderRowDef="getColHeaderDefs()" cdk-header-row></tr>
<tr class="footer-row" *cdkFooterRowDef="getVisibleColDefs()" cdk-footer-row></tr>

<div role="region"
	aria-label="Table"
	#tableContainer
	[class.pcg-table-responsive]="isResponsive"
	[class.pcg-table-fixed-footer]="fixedFooter"
	[class.pcg-table-fixed-header]="fixedHeader"
	class="pcg-table-container mb-1">

	<!-- The table -->
	<table [dataSource]="dataOnPageSource" cdk-table class="data-grid" [class]="'pcg-table-' + tableNum">
		<!-- Displayed if no records are in the table -->
		<ng-container cdkColumnDef="noRecords">
			<td colspan="999" cdk-cell *cdkCellDef="let row">
				<div *ngIf="hasCompletedServerRequest || !serverSide">No records to display</div>
				<div *ngIf="!hasCompletedServerRequest && serverSide">Loading...</div>
			</td>
		</ng-container>

		<!-- Optional per column search -->
		<ng-container *ngFor="let col of getColDefs(); let i = index" [cdkColumnDef]="col + '_search'">
			<th [class]="getColSearchClasses(col)" cdk-header-cell *cdkHeaderCellDef="let row">
				<input *ngIf="canSearch(col) && isNdc(col)"
					[value]="perColumnSearchSource.value[i]"
					(keyup)="updatePerColumnSearch(i, $event.target.value)"
					[attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
					placeholder="Search..."
					class="form-control form-control-sm"
					mask="00000-0000-00"
					type="search" />
				<input *ngIf="canSearch(col) && !isNdc(col)"
					[value]="perColumnSearchSource.value[i]"
					(keyup)="updatePerColumnSearch(i, $event.target.value)"
					[attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
					placeholder="Search..."
					class="form-control form-control-sm"
					type="search" />
			</th>
		</ng-container>

		<!-- Header and Row Declarations -->
		<tr cdk-header-row *cdkHeaderRowDef="getVisibleColDefs()"></tr>
		<tr cdk-row *cdkRowDef="let row; when: hasData; columns: getVisibleColDefs()" [class]="isRowClickable === true ? 'clickable-row' : ''"></tr>
		<tr cdk-row *cdkRowDef="let row; when: hasNoData; columns: ['noRecords']"></tr>
	</table>
</div>

<!-- Pagination and page count -->
<div class="d-flex align-items-start">
	<div class="bottom-left-container filter-count-container form-inline">
		<div class="d-flex align-items-start">
			<span class="sm">Show</span>
			<select (change)="pageSizeSource.next($event.target.value)" class="form-control form-control-sm mx-sm-1 pageSize">
				<option aria-label="Table page length" [selected]="pageSizeSource.value === length" *ngFor="let length of pageLengths">
					{{ length }}
				</option>
			</select>
		</div>		
	</div>	

	<div *ngIf="showPagination" class="w-100 mb-2 clearfix">
		<div role="status" aria-live="polite" class="filter-count-container">
			Showing
			{{ filteredDataCount === 0 ? 0 : ((currentPageSource.value - 1) * pageSizeSource.value + 1 | number) }}
			to
			{{
				(filteredDataCount < currentPageSource.value * pageSizeSource.value
					? filteredDataCount
					: currentPageSource.value * pageSizeSource.value
				) | number
			}}
			of
			{{ filteredDataCount | number }}
			entries
			<span *ngIf="filteredDataCount !== totalDataCount">
				(filtered from {{ totalDataCount | number }} total entries)
			</span>
		</div>
		<div class="pagination-container">
			<ngb-pagination role="navigation"
				aria-label="Table paging"
				[collectionSize]="filteredDataCount"
				[pageSize]="pageSizeSource.value"
				[page]="currentPageSource.value"
				(pageChange)="currentPageSource.next($event)"
				[maxSize]="5"
				[rotate]="true">
			</ngb-pagination>
		</div>
	</div>
</div>
